<mat-tab-group (selectedTabChange)="onTabChanged($event)">
  <mat-tab label="Training Events">
    <ng-template matTabContent>
      <div *ngIf="trainingRequirementSkeletonsLoading$ | async; else trainingEventSkeletonsLoaded">
        Loading...
      </div>
      <ng-template #trainingEventSkeletonsLoaded>
        <sd-portal-training-event-audit-list
          [trainingRequirementSkeletons]="trainingRequirementSkeletons$ | async"
          (opened)="loadTrainingRequirementAudits($event)"
          [loading]="trainingRequirementAuditLoading$ | async"
          [audits]="trainingRequirementAudits$ | async"
          (nextPage)="nextTrainingRequirementAuditPage($event)"
          [warningRuleAudits]="warningRuleAudits$ | async"
          [warningRuleAuditLoading]="warningRuleAuditLoading$ | async"
          (openedWarningRule)="loadWarningRuleAudits($event)"
          (nextWarningRulePage)="nextWarningRuleAuditPage($event)"
        >
        </sd-portal-training-event-audit-list>
      </ng-template>
    </ng-template>
  </mat-tab>

  <mat-tab label="Staff Members">
    <ng-template matTabContent>
      <div *ngIf="businessPersonWithTrainingSkeletonsLoading$ | async; else skeletonsLoaded">
        Loading...
      </div>
      <ng-template #skeletonsLoaded>
        <sd-portal-staff-member-list
          [businessPersonWithTrainingSkeletons]="businessPersonWithTrainingSkeletons$ | async"
          [loading]="businessPersonTrainingRequirementAuditLoading$ | async"
          [audits]="businessPersonTrainingRequirementAudits$ | async"
          (opened)="loadBusinessPersonTrainingRequirementAudits($event)"
          (nextPage)="nextBusinessPersonTrainingRequirementAuditPage($event)"
        >
        </sd-portal-staff-member-list>
      </ng-template>
    </ng-template>
  </mat-tab>
  <mat-tab label="Training Groups">
    <ng-template matTabContent>
      <div *ngIf="trainingGroupSkeletonsLoading$ | async; else trainingGroupSkeletonsLoaded">
        Loading...
      </div>
      <ng-template #trainingGroupSkeletonsLoaded>
        <sd-portal-training-group-audit-list
          [trainingGroupSkeletons]="trainingGroupSkeletons$ | async"
          (opened)="loadTrainingGroupAudits($event)"
          [loading]="trainingGroupAuditLoading$ | async"
          [audits]="trainingGroupAudits$ | async"
          (nextPage)="nextTrainingGroupAuditPage($event)"
          [trainingGroupTrainingRequirementAudits]="trainingGroupTrainingRequirementAudits$ | async"
          [trainingGroupTrainingRequirementAuditLoading]="
            trainingGroupTrainingRequirementAuditLoading$ | async
          "
          (openedTrainingGroupTrainingRequirement)="
            loadTrainingGroupTrainingRequirementAudits($event)
          "
          (nextTrainingGroupTrainingRequirementPage)="
            (nextTrainingGroupTrainingRequirementAuditPage)
          "
        >
        </sd-portal-training-group-audit-list>
      </ng-template>
    </ng-template>
  </mat-tab>
</mat-tab-group>
